import React, { forwardRef } from 'react';
import { INPUT_BASE } from './Input';

const Textarea = forwardRef(function Textarea({ invalid = false, rows = 3, className = '', ...rest }, ref) {
  const borderClass = invalid ? 'border-red-500 dark:border-red-400' : 'border-edge-strong';
  return <textarea ref={ref} rows={rows} className={`${INPUT_BASE} ${borderClass} resize-y ${className}`} {...rest} />;
});

export default Textarea;
